



import { Vue, Component } from "vue-property-decorator";
import { mapState, mapMutations } from "vuex";
import shortcuts from "@/constants/shortcuts";
import SlcShortcuts from "./SlcShortcuts.vue";
import useMatomoEvent from "@/composition/useMatomoEvent";
import router from "@/router";

const getShortcuts = () => [...shortcuts];

/**
 * @returns {Object} - Maps a shortcut object to include a router path object
 */
const mapShortcutItem = ({ $route }) => item => ({
  ...item,
  to: {
    params: {
      viewMode: item.viewMode
    },
    query: {
      view: router.currentRoute?.query.view || "long",
      startDate: item.startDate || $route.query.startDate,
      endDate: item.endDate || $route.query.endDate,
      shortcut: item.title
    }
  }
});

@Component({
  inject: ["eventBus"],
  components: {
    SlcShortcuts
  },
  computed: {
    ...mapState("stageconfig", ["config"])
  },
  methods: {
    ...mapMutations("filterRules", ["setFilterRules"])
  }
})
export default class SlcShortcutsProvider extends Vue {
  eventBus!: Vue;

  setFilterRules: any;

  config: any;

  get items() {
    return getShortcuts()
      .map(this.getShortcutItem())
      .filter(item => {
        if (this.config.features.enableGraphics) return true;
        return item.title !== "latestGraphics";
      });
  }

  getShortcutItem() {
    return mapShortcutItem(this);
  }

  /**
   * Pushes a shortcut's path to the router and sets the respective filterRules when
   * a shortcut is clicked.
   */
  selectShortcut({ to, filterRules, emitEvent = "", title }) {
    const trackingActions = {
      latest: "Alle Einträge",
      myFavorites: "Meine Favoriten",
      latestText: "Neueste Texte",
      latestPictures: "Neueste Bilder",
      latestGraphics: "Neueste Grafiken"
    };

    useMatomoEvent({
      category: "Left Navigation Bar",
      action: `Click "${trackingActions[title]}"`,
      name: "Quick Filters"
    });

    this.$router.push(to);
    if (emitEvent) {
      this.eventBus.$emit(emitEvent);
    }
    // NB: setting of shortcut filterRules. To avoid side-effects
    // (i.e. empty filterRules array), a mapped list is used
    this.setFilterRules({ filterRules: [...filterRules] });
  }
}
